import { Component } from "react";

import debounce from "lodash-es/debounce";
import { Highcharts } from "extensions/highcharts";

import {
    HighchartsChart,
    Chart,
    HighchartsProvider,
    YAxis,
    XAxis,
    ColumnSeries
} from "react-jsx-highcharts";
import { toHex } from "common/colors";
import { getDefaultSymbol, abbreviateNumber } from "common/formats";
import { drillThrough } from "../widgetHelper";

export class TrendlineBottomChart extends Component {
    resizeMethod = debounce(() => this.reflowChart(), 300);
    
    componentDidMount() {
        window.addEventListener("resize", this.resizeMethod);
    }
    
    componentWillUnmount() {
        this.resizeMethod.cancel();
        window.removeEventListener("resize", this.resizeMethod);
    }
    
    getChart = (chart) => {
        this.chart = chart;
    };
    
    getChartHeight() {
        return Math.round((this.props.widgetContainer.offsetHeight - 100 - 80) / 2);
    }
    
    reflowChart() {
        if (this.chart) {
            this.chart.reflow();
            this.chart.setSize(null, this.getChartHeight());
        }
    }
    
    render() {
        const defaultSymbol = getDefaultSymbol();
        const drillDown = (e) => {
            drillThrough(this.props);
        };
        const chartOptions = {
            plotOptions: {
                series: {
                    cursor: "pointer",
                    point: {
                        events: {
                            click(e) {
                                drillDown(e);
                            }
                        }
                    },
                    states: {
                        inactive: {
                            opacity: 1
                        },
                        hover: {
                            brightness: -0.2 // darken
                        }
                    }
                }
            },
            chart: {
                height: this.getChartHeight(),
                marginTop: 10,
                marginRight: 10,
                marginBottom: 60,
                marginLeft: 60,
                backgroundColor: "rgba(0,0,0,0)"
            },
            yAxis: {
                gridLineWidth: 0,
                minorGridLineWidth: 0,
                lineColor: "transparent",
                minorTickLength: 0,
                tickLength: 0,
                labels: {
                    formatter() {
                        const value = abbreviateNumber(this.value);
                        return `${defaultSymbol}${value}`;
                    }
                }
            },
            xAxis: {
                startOnTick: false,
                endOnTick: false,
                minPadding: 0,
                maxPadding: 0,
                minorGridLineWidth: 0,
                lineColor: toHex("gray-soft"),
                lineWidth: 1,
                minorTickLength: 0,
                tickLength: 0
            },
            tooltip: {
                enabled: false
            },
            legend: {
                enabled: false
            }
        };
        
        return (
            <div className="chartArea">
                <HighchartsProvider Highcharts={Highcharts}>
                    <HighchartsChart callback={this.getChart} plotOptions={chartOptions.plotOptions}>
                        <Chart reflow="true" {...chartOptions.chart} />
    
                        <XAxis categories={this.props.chartData.axis} {...chartOptions.xAxis} />
    
                        <YAxis {...chartOptions.yAxis}>
                            <ColumnSeries name="Current" color={toHex("wcag-blue-300")} data={this.props.chartData.current.map((r) => r.bottomField)} />
                            <ColumnSeries name="Previous" color={toHex("paz-black-l-30")} data={this.props.chartData.previous.map((r) => r.bottomField)}/>
                        </YAxis>
                    
                    </HighchartsChart>
                </HighchartsProvider>
            </div>
        );
    }
}
